var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNp = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.176,
    height: 10.176,
    viewBox: "0 0 10.176 10.176",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_info_3556168_000000",
    transform: "translate(-18 -18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5771",
    "data-name": "Path 5771",
    d: "M23.088,18a5.087,5.087,0,1,0,3.6,1.49A5.089,5.089,0,0,0,23.088,18Zm0,8.9a3.817,3.817,0,1,1,2.7-1.118A3.814,3.814,0,0,1,23.088,26.9Z",
    fill: "#5c3cc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5772",
    "data-name": "Path 5772",
    d: "M46,48h1.272v2.862H46Z",
    transform: "translate(-23.548 -25.23)",
    fill: "#5c3cc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5773",
    "data-name": "Path 5773",
    d: "M47.272,34.637a.636.636,0,0,1-1.272,0,.636.636,0,0,1,1.272,0",
    transform: "translate(-23.548 -13.457)",
    fill: "#5c3cc2"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/np.d7ba44b2.svg";
export { ForwardRef as ReactComponent };